<template>
    <div class="kgk-manage-company">
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="company">
            <p>{{ company.name }}</p>
            <p>{{ company.street }} {{ company.street_number }}</p>
            <p>{{ company.zip }} {{ company.city }}</p>
            <div v-if="company.competition_mode == 1">
                <i class="fas fa-shoe-prints"></i>
                <span> {{ competitionModeReadable }} </span>
                <i class="fas fa-shoe-prints"></i>
            </div>
            <div v-if="company.competition_mode == null">
                <i class="fas fa-running"></i>
                <span> {{ competitionModeReadable }} </span>
                <i class="fas fa-running"></i>
            </div>
            
        </div>
        <p></p>
        <p>
            <i class="fas fa-info-circle"></i>
            Du kannst diesen Link teilen und so Nutzer der Firma und Company-Challenge hinzufügen.
        </p>
        <textarea id="inviteMassCompanyLink" readonly style="border:1px solid #000" v-model="inviteMassCompanyLink"></textarea>
        <div v-if="employees">
            <table>
                <thead>
                    <th>Vorname</th>
                    <th>Nachname</th>
                    <th>E-Mail</th>
                    <th>Mitgliedschaft verifiziert</th>
                </thead>
                <tbody>
                    <tr v-for="(employee, i) in employees" :key="i">
                        <td>{{ employee.prename }}</td>
                        <td>{{ employee.surname }}</td>
                        <td>{{ employee.email }}</td>
                        <td><input type="checkbox" true-value="1" false-value="null" v-model="employee.company_connection_verified" @click="updateCompanyConnectionVerified(employee.identifier, employee.company_connection_verified == 1 ? null : 1)" :disabled="$parent.user.companyAdmin==1 && $parent.user.identifier==employee.identifier" /></td>
                    </tr>
                </tbody>
            </table>
            
        </div>
        
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import company from '../../api/company';
    import userApi from '../../api/user';

    export default {
        name: 'CompanyManager',
        components: {

        },
        props: ['user'],
        data() {
            return {
                loading: false,
                company: {},
                employees: {},
                inviteMassCompanyLink: '',
            }
        },
        computed: {
            competitionModeReadable: function(){
                //console.log(this.company.competition_mode)
                if(this.company.competition_mode == 1){
                    return 'Deine Firma nimmt an der Schrittzähler Challenge teil!';
                }else{
                    return 'Deine Firma nimmt an der Lauf Challenge teil!';
                }
            }
        },
        watch: {
        },
        methods: {
            loadCompany() {
                this.loading = true;

                company.getDetails(
                    this,
                    data => {
                        this.company = data.company,
                        this.employees = data.employees
                    },
                    () => this.error = 'Es ist ein Fehler aufgetreten',
                    () => this.loading = false,
                );
            },
            // The invite link has to be a real InviteLink.identifier (backend
            // validates against the invite_links table) -- reuse an existing
            // active one if there is one, otherwise mint a new one.
            loadInviteLink() {
                company.inviteLinks(
                    this,
                    data => {
                        const active = (data.inviteLinks || []).find(l => l.status === 'active');
                        if (active) {
                            this.setInviteMassCompanyLink(active.identifier);
                        } else {
                            this.generateInviteLink();
                        }
                    },
                    () => this.generateInviteLink(),
                );
            },
            generateInviteLink() {
                company.generateInviteLink(
                    this,
                    data => this.setInviteMassCompanyLink(data.inviteLink.identifier),
                    () => {},
                );
            },
            setInviteMassCompanyLink(identifier) {
                this.inviteMassCompanyLink = `${window.baserouteApp}#/profile/acceptCompanyInviteMass/${identifier}`;
            },
            updateCompanyConnectionVerified(user_identifier, company_connection_verified_value) {
                this.loading = true;

                let data = {'user_identifier': user_identifier, 'company_connection_verified': company_connection_verified_value};

                userApi.updateCompanyVerification(
                    this,
                    data,
                    () => {
                        this.loadCompany();
                    },
                    () => alert('Es ist ein Fehler aufgetreten'),
                    () => this.loading = false,
                )
            }
        },
        mounted() {
            this.loadCompany();
            this.loadInviteLink();
        }
    }
</script>
